import requestOld from 'lib/helpers/request';
import { ResponseTranslation } from 'domains/campaigns/types';
import { TParams } from 'domains/target/types';
import request from '../../lib/helpers/requestApi';
import { THASH, THASH_LIST, TID, TInternalList, TPretargeting } from '../../types/general';
import {
  CreativeDetail,
  CreativeList,
  TModerationTypes,
  ParamRequestClone,
  PChangeStatusCreative,
  PFormatting,
  PGetCreative,
  PGetCreativeDetail,
  PsetExternalId,
  RCreativeClone,
  RFormatting,
  RModerationResult,
  RPreviewCreative,
  TFormikCreativeAddSaga,
  TPCreativeEdit,
  TPModerationSentAPI,
  RAlgorithmCreativeList,
  RCreativeTags,
  PSetCreativeTags,
  TPCreativesAllStatus,
  TPCreativeGroupStatus,
  TPSetCreativePretargeting,
  TRCreativeTypes,
  TScreenStatus,
  MassEditLinkParams,
  getCustomerByEridParams,
  IGetTemplateListData,
  ICheckEridStatusOrdFieldsData,
  THashCallbackParams,
  IGetContractGridInfo,
  IScreenshotDomains,
  ICreativeInfoForMassEridStatusProps,
  ICreativeInfoForMassEridStatusData,
  TGetContractGridInfo,
  TSendCreativesInGrid,
  IGetMassCreativeAddTaskListData,
  TGetMassCreativeAddTaskProps,
  IGetMassCreativeAddTaskData,
  IMarkCreateData,
} from './types';

/** Получение списка крео */
export const getCreativeList = request<CreativeList, PGetCreative>({
  method: 'creative.getList',
});
/** Получение детального описания крео */
export const getCreativeDetail = request<CreativeDetail, PGetCreativeDetail>({
  method: 'creative.getInfo',
});

/** Изменение статуса креатива */
export const creativeSetStatusApi = request<boolean, PChangeStatusCreative>({
  method: 'creative.setStatus',
});
/** Очистка таргетов креатива */
export const cleanTargetCreative = request<boolean, THASH>({
  method: 'targeting.removeAll',
});
/** Дублирование креатива */
export const cloneCreative = request<RCreativeClone[], ParamRequestClone>({
  method: 'cloning.creative',
  showError: false,
});
/** Функция редактирования креатива */
export const setCreativeEdit = request<boolean, TPCreativeEdit>({
  method: 'creative.edit',
});

/** Получение статуса модерации */
export const statusModeration = request<TModerationTypes, { creative_id: string }>({
  method: 'moderation.allStatus',
});

/** Отправка на модерацию */
export const sendExternalModeration = request<
  RModerationResult,
  TPModerationSentAPI
>({
  method: 'moderation.send',
});

/** Получение Preview для креатива */
export const getPreviewCreative = request<RPreviewCreative, THASH>({
  method: 'creative.getPersonalPreview',
});
/** Создание кратива */
export const addCreative = request<TID, TFormikCreativeAddSaga>({
  method: 'creative.add',
});

/** Обработка кода */
export const formattingShowMethodsThisContext = request<
  RFormatting,
  PFormatting
>({
  method: 'formatting.showMethodsForThisContext',
});

/** Отправка ExternalId  */
export const setExternalId = request<boolean, PsetExternalId>({
  method: 'creative.setExternalId',
});

/** Метод получения алгоритмов в креативах */
export const getCreativeAlgorithms = request<RAlgorithmCreativeList>({
  method: 'creative.getAlgorithmsCpc',
});

/** метод для получения тегов креатива */
export const getCreativeTags = request<RCreativeTags, THASH>({
  method: 'creative.getTags',
});
/** метод изменения тегов в креативе */
export const setCreativeTagsAPI = request<boolean, PSetCreativeTags>({
  method: 'creative.setTags',
});
/** метод получениия списка тегов всех креативов кампании */
export const getAllCreativeTags = request<RCreativeTags, THASH>({
  method: 'campaign.getAllCreativesTags',
});

export const getInternalList = request<TInternalList, { key: string }>({
  method: 'internalList.getByKey',
});

export const setAllStatuses = request<boolean, TPCreativesAllStatus>({
  method: 'campaign.setStatusesInCampaignCreatives',
});

export const setGroupStatuses = request<boolean, TPCreativeGroupStatus>({
  method: 'campaign.setStatusesInCreativeList',
});

export const clearTargetAllCreativesByCampaign = request<boolean, THASH>({
  method: 'targeting.removeAllInCreativesByCampaign',
});

export const clearTargetToList = request<boolean, THASH_LIST>({
  method: 'targeting.removeAllToList',
});

export const unsetCreativeTargeting = request<
  boolean,
  TParams
>({
  method: 'targeting.removeByKey',
  showError: false,
});

export const getCreativePretargeting = request<TPretargeting | [], THASH>({
  method: 'creative.getPretargeting',
});

export const setCreativePretargetingApi = request<
  boolean,
  TPSetCreativePretargeting
>({
  method: 'creative.setPretargeting',
});

export const removeCreativePretargetingApi = request<boolean, THASH>({
  method: 'creative.removePretargetings',
});

export const fetchCreativesTranslationApi = request<
  Record<string, ResponseTranslation>,
  THASH
>({
  method: 'campaign.checkCreativesExport',
});

export const fetchCreativeTranslationApi = request<ResponseTranslation, THASH>({
  method: 'creative.checkExport',
});

export const getAllCreativeTypesApi = request<TRCreativeTypes>({
  method: 'campaign.getAllCreativeTypes',
});

export const createScreenAPI = request<boolean, THASH>({
  method: 'screenshot.create',
});

export const getScreenStatusAPI = request<TScreenStatus, THASH>({
  method: 'screenshot.getStatus',
});

export const massEditLinkAPI = request<boolean, MassEditLinkParams>({
  method: 'massEdit.creative',
});

export const getCustomerByEridAPI = request<getCustomerByEridParams | string[], {erid: string}>({
  method: 'creative.getCustomerByErid',
});

export const getTemplateList = request<IGetTemplateListData[], { creative_type: CreativeDetail['type'] }>({
  method: 'creative.getTemplateList',
});

/** Данный метод создает креатив и ресурсы для него в Grid для получения Erid */
export const sendCreativeInGridAPI = request<boolean, THashCallbackParams>({
  method: 'creative.sendCreativeToGrid',
});

/** Данный метод отправляет массово креативы в таблицу grid_request для последующей отправки в грид */
export const sendCreativesInGridAPI = request<boolean, TSendCreativesInGrid>({
  method: 'creative.sendCreativesToGrid',
});

/** Данный метод возвращает текущий статус креатива из Grid */
export const checkEridStatusOrdFields = request<ICheckEridStatusOrdFieldsData, THashCallbackParams>({
  method: 'creative.checkEridStatusOrdFields',
});

/** Данный метод возвращает информацию по компании и контракту из Grid */
export const getContractGridInfoAPI = request<IGetContractGridInfo, TGetContractGridInfo>({
  method: 'creative.getContractGridInfo',
});

/** Получаем список доменов для скриншота */
export const getScreenshotDomainsAPI = request<IScreenshotDomains[]>({
  method: 'screenshot.getDomains',
});

/** Получаем инфу для креативов при массовом редактировании ерид */
export const getCreativeInfoForMassEridStatusAPI = request<ICreativeInfoForMassEridStatusData[], ICreativeInfoForMassEridStatusProps>({
  method: 'creative.getCreativeInfoForMassEridStatus',
});

/** Получаем инфу для cписка задач по массовому созданию крео */
export const getMassCreativeAddTaskListAPI = request<IGetMassCreativeAddTaskListData[]>({
  method: 'massCreate.getMassCreativeAddTaskList',
});

/** Получаем инфу по конкретной задаче по массовому созданию крео */
export const getMassCreativeAddTaskAPI = request<IGetMassCreativeAddTaskData, TGetMassCreativeAddTaskProps>({
  method: 'massCreate.getMassCreativeAddTask',
});

/** Следующие методы следует отрефакторить  */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getFormatting = (params: { html: string; method: string }) =>
  requestOld<{ html: string }, string>({
    method: `formatting.${params.method}`,
    params: { html: params.html },
  });

/** Отправка запроса на создание видео с маркировкой в грид */
export const markCreateAPI = request<IMarkCreateData, THASH>({
  method: 'mark.create',
});

/** Удаление маркировки в грид */
export const markRemoveAPI = request<boolean, THASH>({
  method: 'mark.remove',
});

/** получение статуса и информации по маркированному видео */
export const markGetStatusAPI = request<IMarkCreateData, THASH>({
  method: 'mark.getStatus',
});
